<script>
export default {
  name: 'custom-input',
  data() {
    return {
      value: '',
    };
  },
  props: {
    name: String,
    defaultValue: {
      type: String,
      default: '',
    },
    isValid: Boolean,
    modelValue: {
      type: [String, Object],
    },
    type: String,
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
  },
  model: {
    prop: 'modelValue',
  },
  mounted() {
    if (
      this.defaultValue !== undefined &&
      !(this.defaultValue === this.modelValue && this.modelValue === '')
    ) {
      this.value = this.defaultValue;
      return this.$emit('input', this.defaultValue);
    }
  },

  render(h) {
    const self = this;

    return h('input', {
      attrs: this.$attrs,
      props: this.$props,
      class: {
        'is-invalid': !this.$props.isValid,
      },
      on: {
        input: function(event) {
          self.value = event.target.value;
          self.$emit('input', self.value);
        },
      },
      domProps: { value: self.modelValue },
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
input.is-invalid {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomInput.vue